export const contactReason = {
    'en': [{
        name: 'Buy',
        value: 'buy'
    },
    {
        name: 'Sell',
        value: 'sell'
    },
    {
        name: 'Rent',
        value: 'rent'
    },
    {
        name: 'Other',
        value: 'other'
    }],
    'cn': [{
        name: '购买',
        value: 'buy'
    },
    {
        name: '卖出',
        value: 'sell'
    },
    {
        name: '出租',
        value: 'rent'
    },
    {
        name: '其他',
        value: 'other'
    }],
    'th': [{
        name: 'Buy',
        value: 'buy'
    },
    {
        name: 'Sell',
        value: 'sell'
    },
    {
        name: 'Rent',
        value: 'rent'
    },
    {
        name: 'Other',
        value: 'other'
    }],

}